import { get } from 'lodash'
import { Deserialize } from 'cerialize'
import {
	partnerSettingApi,
	PartnerSettingModel,
	partnerSettingSelectors,
	PartnerSettingsNS,
	partnerSettingsSlice,
} from 'Pages/coliseum'
import { RequestParams, ResponseCatalog } from 'Models'
import { call, put, takeLatest, select } from 'typed-redux-saga'
import { loadersSlice, NOTIFICATION_TYPE, showNotificationAction, gridSlice } from 'Modules'

function* getAll(action: PartnerSettingsNS.GetAll) {
	try {
		const { params, clear } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(partnerSettingsSlice.actions.clearAll())
		}
		const res = yield* call(partnerSettingApi.getAll, params)
		const items = new ResponseCatalog<PartnerSettingModel>(res)
		items.entries = items.entries.map(
			(item): PartnerSettingModel => Deserialize(item, PartnerSettingModel)
		)
		if (!clear) {
			const oldItems = yield* select(partnerSettingSelectors.getAll)
			items.entries = [...oldItems.entries, ...items.entries]
		}
		yield* put(partnerSettingsSlice.actions.setAll(items))
		yield* put(partnerSettingsSlice.actions.setRequestParams(params))
	} catch (e) {
		const errors = get(e, 'data.errors', [])
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Произошла ошибка при получении списка ограничений',
				errors,
			})
		)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: PartnerSettingsNS.GetOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const id = action.payload
		const res = yield* call(partnerSettingApi.getOne, id)
		const item = Deserialize(res, PartnerSettingModel)
		yield* put(partnerSettingsSlice.actions.setOne(item))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (e) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = get(e, 'data.errors', [])
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Произошла ошибка при получении данных ограничения',
				errors,
			})
		)
	}
}

function* updateOne(action: PartnerSettingsNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(partnerSettingApi.updateOne, action.payload)
		yield* put(
			partnerSettingsSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.SUCCESS,
				message: 'Изменение сохранено',
			})
		)
	} catch (e) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = get(e, 'data.errors', [])
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Произошла ошибка при обновлении ограничения',
				errors,
			})
		)
	}
}

function* createOne(action: PartnerSettingsNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(partnerSettingApi.createOne, action.payload)
		yield* put(
			partnerSettingsSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.SUCCESS,
				message: 'Ограничение создано',
			})
		)
	} catch (e) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = get(e, 'data.errors', [])
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Произошла ошибка при создании ограничения',
				errors,
			})
		)
	}
}

export function* partnerSettingSaga() {
	yield* takeLatest(partnerSettingsSlice.actions.getAll, getAll)
	yield* takeLatest(partnerSettingsSlice.actions.getOne, getOne)
	yield* takeLatest(partnerSettingsSlice.actions.updateOne, updateOne)
	yield* takeLatest(partnerSettingsSlice.actions.createOne, createOne)
}
